import type { IconNode } from '../types';

/**
 * @name broom
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTMgMTEgOS05IiAvPgogIDxwYXRoIGQ9Ik0xNC42IDEyLjZjLjguOC45IDIuMS4yIDNMMTAgMjJsLTgtOCA2LjQtNC44Yy45LS43IDIuMi0uNiAzIC4yWiIgLz4KICA8cGF0aCBkPSJtNi44IDEwLjQgNi44IDYuOCIgLz4KICA8cGF0aCBkPSJtNSAxNyAxLjQtMS40IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/broom
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const broom: IconNode = [
  ['path', { d: 'm13 11 9-9', key: 'hhupzs' }],
  ['path', { d: 'M14.6 12.6c.8.8.9 2.1.2 3L10 22l-8-8 6.4-4.8c.9-.7 2.2-.6 3 .2Z', key: '125lmh' }],
  ['path', { d: 'm6.8 10.4 6.8 6.8', key: '8ijsh8' }],
  ['path', { d: 'm5 17 1.4-1.4', key: 'rw7fu1' }],
];

export default broom;
